@import "../../../less/variables.less";

.tjenesteInfoContainer {
  display: flex;
  gap: var(--dds-spacing-small-16);
  justify-content: space-around;
  margin-bottom: var(--dds-spacing-medium-32);
}

.nesteOgTilbakeKnapp {
  margin-top: var(--dds-spacing-medium-24);
  margin-bottom: var(--dds-spacing-large-48);
}
